import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export enum ReportLevel {
  Program,
  Institution
}

type ReportSelectionPromptProps = {
  reportLevel: ReportLevel;
};

export const ReportSelectionPrompt = ({
  reportLevel
}: ReportSelectionPromptProps) => {
  const { t } = useTranslation();
  const selection =
    reportLevel === ReportLevel.Program ? "program" : "institution";
  return (
    <Alert severity="warning">
      {t(`Please select a ${selection} above to view the report.`)}
    </Alert>
  );
};
